"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var simple_header_layout_1 = require("./internal/simple-header-layout");
exports.SimpleHeaderLayoutMap = simple_header_layout_1.SimpleHeaderLayoutMap;
var multi_layout_1 = require("./internal/multi-layout");
exports.MultiLayoutMap = multi_layout_1.MultiLayoutMap;
